<template>
	<div>
		<sui-modal v-model="open" size="large">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont"
						>{{ editar ? 'Editar' : 'Crear' }} aspirante</strong
					>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-form @submit.prevent>
						<sui-form-fields>
							<BaseInput
								v-model="aspirante.ficha"
								titulo="Ficha"
								placeholder="Ficha"
								class="four wide field"
								type="text"
								:error="erroresValidacion && !validationFicha"
								:disabled="editar"
							></BaseInput>
							<BaseInput
								v-model="aspirante.nombreCompleto"
								titulo="Nombre completo"
								placeholder="Nombre completo"
								class="twelve wide field"
								type="text"
								:error="erroresValidacion && !validationNombre"
							></BaseInput>
						</sui-form-fields>
						<sui-form-fields fields="three">
							<BaseInput
								v-model="aspirante.curp"
								titulo="CURP"
								placeholder="CURP"
								class="field"
								type="text"
								:maxlength="18"
								:error="erroresValidacion && !validationCurp"
							></BaseInput>
							<BaseInput
								v-model="aspirante.correoElectronico"
								titulo="Correo electrónico"
								placeholder="Correo electrónico"
								class="field"
								type="text"
								:error="erroresValidacion && !validationCorreo"
							></BaseInput>
							<BaseSelectCarreras
								v-model="aspirante.claveCarrera"
								titulo="Carrera"
								placeholder="Seleccione una carrera"
								class="field"
								:error="erroresValidacion && !validationCarrera"
							></BaseSelectCarreras>
						</sui-form-fields>
						<base-button
							class="boldFont"
							style-button="primary"
							style-class="right floated"
							:loading="loading"
							@click.native="toggle"
							>Guardar</base-button
						>
					</sui-form>
				</sui-modal-description>
			</sui-modal-content>
		</sui-modal>
	</div>
</template>
<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		editar: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			open: false,
			aspirante: {},
			erroresValidacion: false
		};
	},
	computed: {
		...mapGetters('aspirantes', ['getAspirante']),
		validationFicha() {
			return (
				this.aspirante.ficha !== undefined && this.aspirante.ficha.trim() !== ''
			);
		},
		validationNombre() {
			return (
				this.aspirante.nombreCompleto !== undefined &&
				this.aspirante.nombreCompleto.trim() !== ''
			);
		},
		validationCurp() {
			return (
				this.aspirante.curp !== undefined && this.aspirante.curp.trim() !== ''
			);
		},
		validationCorreo() {
			return (
				this.aspirante.correoElectronico !== undefined &&
				this.aspirante.correoElectronico.trim() !== ''
			);
		},
		validationCarrera() {
			return (
				this.aspirante.claveCarrera !== undefined &&
				this.aspirante.claveCarrera.trim() !== ''
			);
		}
	},
	watch: {
		open(val) {
			if (!val) {
				this.erroresValidacion = false;
				this.SET_ASPIRANTE({});
				this.$emit('input', {});
			}
		},
		getAspirante(val) {
			if (!_.isEmpty(val) && this.editar) {
				this.aspirante = {
					ficha: val.ficha,
					nombreCompleto: val.nombreCompleto,
					correoElectronico: val.correoElectronico,
					curp: val.curp,
					claveCarrera: val.claveCarrera
				};
				this.$emit('input', this.aspirante);
			} else {
				this.aspirante = {};
			}
		}
	},
	mounted() {},
	methods: {
		...mapMutations('aspirantes', ['SET_ASPIRANTE']),
		toggle($event) {
			event.preventDefault();
			if (this.open) {
				if (
					this.validationFicha &&
					this.validationNombre &&
					this.validationCurp &&
					this.validationCorreo &&
					this.validationCarrera
				) {
					this.erroresValidacion = false;
					this.$emit('input', this.aspirante);
					if (this.editar) {
						this.$emit('editar');
					} else {
						this.$emit('guardar');
					}
				} else {
					this.erroresValidacion = true;
				}
			} else {
				this.open = !this.open;
			}
		},
		close() {
			this.open = false;
		},
		aceptar() {}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
